import { useState } from 'react'
import { Profile } from './Profile'
import { Card, Modal, Space } from 'antd'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { CloseOutlined, LinkOutlined } from '@ant-design/icons'
import SBInstagramConnect from '../../modules/authorization-modal/connect'
import { Link } from 'react-router-dom'

interface Props {
  onCreated: () => void
}

/**
 * Usage of Modal is postponed for now
 * On Instagram Sucess, some components are re-rendered which closes the modal
 *
 * The card redirects to the Instagram Connect Flow at /onboarding/instagram
 */
export const ProfileAddModal = ({ onCreated }: Props) => {
  //   const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)

  return (
    <Link to="/onboarding/instagram">
      <Card
        className="profile-card bg-pink border-purple"
        // onClick={() => {
        //   setModalIsOpen(true)
        // }}
        style={{
          cursor: 'pointer',
          borderStyle: 'dashed',
          borderWidth: 2,
          flex: 1,
          height: '100%',
        }}
        styles={{
          body: {
            height: '100%',
            alignContent: 'center',
            justifyItems: 'center',
          },
        }}
      >
        <Space size={5} style={{ color: '#a58aeb', fontWeight: 600 }}>
          <LinkOutlined />
          {i18n.t(LocalizationKeys.Component.Profile.AddCard.Connect)}
        </Space>
      </Card>
      {/* <Modal
        open={modalIsOpen}
        footer={<></>}
        destroyOnClose
        closeIcon={
          <CloseOutlined
            onClick={() => {
              // Controling here with onClick() allows to close the modal only when the closeIcon is clicked
              // and not when the mask around is clicked
              setModalIsOpen(false)
            }}
          />
        }
      >
        <Profile.ConnectFlow onCreated={onCreated} />
      </Modal> */}
    </Link>
  )
}

export type ProfileAddModalType = { AddModal: typeof ProfileAddModal }
